var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOfficeinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 1h18v1h-8v4h8v1h-8v4h8v1h-8v4h8v5h-1v-4h-5v4H3V1Zm13 20h3v-3h-3v3Zm-1 1H1v1h22v-1h-8Zm7-6v5h2v3H0v-3h2V0h20v16ZM21 5V3h-7v2h7Zm-7 3h7v2h-7V8Zm7 7v-2h-7v2h7Zm-11-2H5v2h5v-2Zm-6-1v4h7v-4H4Zm1-4h5v2H5V8Zm-1 3V7h7v4H4Zm6-8H5v2h5V3ZM4 2v4h7V2H4Z",
  fill: "#252829"
})));
export default SvgOfficeinline;